
/**
 * @export
 * @enum {string}
 */
export enum AccountSortField {
    ACCOUNT_ID = 'ACCOUNT_ID',
    ACCOUNT_NAME = 'ACCOUNT_NAME',
    ACCOUNT_STATUS = 'ACCOUNT_STATUS',
    PARENT_ACCOUNT_NAME = 'PARENT_ACCOUNT_NAME',
    SALESFORCE_INTEGRATION = 'SALESFORCE_INTEGRATION',
    MS_DYNAMICS_INTEGRATION = 'MS_DYNAMICS_INTEGRATION',
    HUBSPOT_INTEGRATION = 'HUBSPOT_INTEGRATION',
    DEAL_CLOUD_INTEGRATION = 'DEAL_CLOUD_INTEGRATION',
    PRIMARY_ACCOUNT_MANAGER = 'PRIMARY_ACCOUNT_MANAGER',
    LICENSE_TYPE = 'LICENSE_TYPE',
    LICENSE_END_DATE = 'LICENSE_END_DATE',
    LICENSE_START_DATE = 'LICENSE_START_DATE',
    ENTITY_TYPE = 'ENTITY_TYPE',
    COUNTRY = 'COUNTRY',
    IS_DELETED = 'IS_DELETED',
    ENTITY_TYPE_NAME = 'ENTITY_TYPE_NAME',
    SEATS = 'SEATS',
    SSO_ENABLED = 'SSO_ENABLED',
    SSO_MANDATORY = 'SSO_MANDATORY'
}